import {RevokedData} from "@bounce/shared/consumer/declarations";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {
  account_id: string;
  payment_plan_id: string;
  revoked_data: RevokedData;
};

type Data = string;

export const deactivatePaymentPlanForAccount = async (variables: Variables): Promise<Data> => {
  const result = await axiosConsumerAppInstance.post<Data, AxiosResponse<Data>>(
    `/payment_plans/deactivate-payment-plan/${variables.payment_plan_id}`,
    variables.revoked_data
  );

  return result.data;
};

export const useDeactivatePaymentPlanForAccount = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> => {
  return useBaseMutation(deactivatePaymentPlanForAccount, {
    ...options,
    prefixKeysToReset: (data, variables) => [["user"], ["account", variables.account_id]],
  });
};
